import styled from "styled-components";
import Text from "./Text";

export const ProgressText = styled(Text)`
  opacity: 0.5;
  margin-left: auto;
  font-size: 12px;
`;